import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Clock, Lock, MessageCircle, XCircle } from 'lucide-react';
import { Button } from '../components/UI';

// /comunidade/acesso/:token — link rastreado do grupo pago, enviado por e-mail depois do pagamento.
// Mesmo fluxo de /grupo/:token, mas só abre com a assinatura em dia.
const CommunityJoin: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useTranslation();
  const [state, setState] = useState<'loading' | 'ready' | 'expired' | 'noGroup' | 'error'>('loading');
  const [url, setUrl] = useState('');
  const [slug, setSlug] = useState('');

  useEffect(() => {
    let cancelled = false;
    axios.post(`/community/join/${token}`)
      .then((res) => {
        if (cancelled) return;
        setSlug(res.data?.slug || '');
        if (res.data?.url) {
          setUrl(res.data.url);
          setState('ready');
          window.location.replace(res.data.url);
        } else if (res.data?.expired) {
          setState('expired');
        } else {
          setState('noGroup');
        }
      })
      .catch(() => { if (!cancelled) setState('error'); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
      <div className="card max-w-md w-full text-center">
        {state === 'expired' ? (
          <>
            <Lock className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('community.join.expiredTitle')}</h1>
            <p className="text-gray-600 mb-6">{t('community.join.expiredMessage')}</p>
            {slug ? (
              <Button to={`/comunidade/${slug}`}>{t('community.join.renew')}</Button>
            ) : (
              <Button to="/">{t('community.join.backHome')}</Button>
            )}
          </>
        ) : state === 'noGroup' ? (
          <>
            <Clock className="w-12 h-12 text-amber-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('community.join.noGroupTitle')}</h1>
            <p className="text-gray-600 mb-6">{t('community.join.noGroupMessage')}</p>
            <Button to="/">{t('community.join.backHome')}</Button>
          </>
        ) : state === 'error' ? (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">{t('community.join.errorTitle')}</h1>
            <p className="text-gray-600 mb-6">{t('community.join.errorMessage')}</p>
            <Button to="/">{t('community.join.backHome')}</Button>
          </>
        ) : (
          <>
            <MessageCircle className="w-12 h-12 text-[#25D366] mx-auto mb-4" />
            <p className="text-gray-900 font-semibold mb-2">{t('community.join.loading')}</p>
            {state === 'ready' && (
              <>
                <p className="text-gray-600 mb-6">{t('community.join.manual')}</p>
                <a
                  href={url}
                  className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white font-semibold py-3 px-6 rounded-lg"
                >
                  <MessageCircle className="w-5 h-5" />
                  {t('community.join.open')}
                </a>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CommunityJoin;
